import styled from "styled-components";
import { Colors } from "../../ColorConstants";

 
export const PaginationButton = ({
  label,
  isActive,
  onClick,
  disabled,
  children,
}) => {
  return isActive ? (
    <FilledStyledButton onClick={onClick}>
      {label || children}
    </FilledStyledButton>
  ) : (
    <StyledButton disabled={disabled} onClick={onClick}>
      {label || children}
    </StyledButton>
  );
};
 
const StyledButton = styled.button`
  width: 27px;
  height: 27px;
  border: 1px solid ${Colors.lightShadeBlue};
  border-radius: 3px;
  background-color: white;
  color: ${(props) => (props.disabled ? "#C4C4C4" : "#505470")};
  margin-right: 7px;
  font-weight: 400;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  `;

  const FilledStyledButton = styled.button`
  width: 27px;
  height: 27px;
  border: 1px solid ${Colors.solitude};
  border-radius: 3px;
  background-color: ${Colors.black};
  color: ${Colors.white};
  margin-right: 7px;
  font-weight: 400;
  cursor: pointer;
`;